<template>
  <div class="carousel-container">
    <button class="arrow left-arrow" @click="scrollLeft">&#10094;</button>
    <div class="carousel" ref="carousel">
      <div v-for="(Itemdata, index) in ProductosOferta" :key="index">
        <card-oferta-component
          :Itemdata="Itemdata"
          :descuento="Oferta.descuento"
        />
      </div>
    </div>
    <button class="arrow right-arrow" @click="scrollRight">&#10095;</button>
  </div>
</template>

<script>
import ApiOfertas from '@/Api/ApiOfertas';
import CardOfertaComponent from './CardOfertaComponent.vue';

export default {
  components: { CardOfertaComponent },
  props: {
    Oferta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ProductosOferta: [],
    };
  },

  mounted() {
    this.GetAllProducts();
    this.startPolling();
  },
  methods: {
    scrollLeft() {
      const carousel = this.$refs.carousel;
      if (carousel) {
        carousel.scrollBy({ left: -320, behavior: 'smooth' });
      }
    },
    scrollRight() {
      const carousel = this.$refs.carousel;
      if (carousel) {
        carousel.scrollBy({ left: 320, behavior: 'smooth' });
      }
    },
    async GetAllProducts() {
      await ApiOfertas.GetProductsByOferta(this.Oferta.descripcion)
        .then((response) => {
          this.ProductosOferta = response.data;
        })
        .catch((error) => {});
    },
    startPolling() {
      setInterval(() => {
        this.GetAllProducts();
      }, 5000); // 5000 milisegundos = 5 segundos
    },
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>
<style scoped>
.carousel-container {
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  margin: 30px;
}

.carousel {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
}

.card {
  flex: none;
  width: 250px;
  height: 470px;
  margin: 30px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: center;
  line-height: 300px;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
}

.left-arrow {
  left: 0;
}

.right-arrow {
  right: 0;
}
</style>
